import { createActionName } from "redux/utility"

export const reducerName = "stories"

export const STORY = createActionName(reducerName, "STORY")
export const STORIES = createActionName(reducerName, "STORIES")
export const INTRODUCTION = "_INTRODUCTION"
